module.exports = __webpack_public_path__ + "static/media/codigosecreto.58419c67.mp4";